export const ProjectVersion = {
  projectVersion: "Cervino 1.0.0.1"
}